import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { CompaniesService } from '../../../../services/companies';
import { CountryCityService } from '../../../../services/country-city.service';

@Component({
  selector: 'app-createcompany',
  templateUrl: './createcompany.component.html',
  styleUrl: './createcompany.component.scss'
})
export class CreatecompanyComponent implements OnInit {

  data!: FormGroup;
  dataForm: FormData = new FormData();

  contentReady: boolean = false;
  isSubmitting: boolean = false;

  isMobile: boolean = false;
  isAr: boolean = false;

  editId!: any;
  isUpdatePage: boolean = false;

  systemAccess: boolean = false;
  type: string = 'text';

  selectedImage: File | null = null;

  countries: any[] = [];
  cities: any[] = [];

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private _company: CompaniesService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    private countryCityService: CountryCityService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";

    this.initForm();
    this.getCountries();

    this.route.queryParams.subscribe(params => {
      if (params["id"]) {
        this.isUpdatePage = true;
        this.editId = params["id"];

        const countryId = this.toId(params["country_id"]);
        const cityId = this.toId(params["city_id"]);

        this.data.patchValue({
          name: params["name"] || '',
          name_ar: params["name_ar"] || '',

          specialty: params["specialty"] || '',
          industry: params["industry"] || '',

          country_id: countryId,
          city_id: cityId,

          tel: params["tel"] || '',
          fax: params["fax"] || '',
          address: params["address"] || '',
          contact_email: params["contact_email"] || '',
          facebook: params["facebook"] || '',
          linkedin: params["linkedin"] || '',

          is_user:
            params["is_user"] === 'true' ||
            params["is_user"] === true ||
            params["is_user"] == 1,

          is_ahmed_elshahat_client:
            params["is_ahmed_elshahat_client"] === 'true' ||
            params["is_ahmed_elshahat_client"] === true ||
            params["is_ahmed_elshahat_client"] == 1
        });

        if (countryId) {
          this.getCitiesByCountry(countryId, false);
        }
      }
    });

    this.contentReady = true;
  }

  initForm(): void {
    this.data = this.fb.group({
      name: ['', Validators.required],
      name_ar: [''],

      specialty: [''],
      industry: [''],

      country_id: [null],
      city_id: [null],

      tel: [''],
      fax: [''],
      address: [''],
      contact_email: ['', Validators.email],
      facebook: [''],
      linkedin: [''],

      image: [null],

      add_by: [localStorage.getItem("username") || 'Unknown'],

      is_user: [false],
      is_ahmed_elshahat_client: [false]
    });
  }

  toId(value: any): any {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numberValue = Number(value);

    return Number.isNaN(numberValue) ? value : numberValue;
  }

  getCountries(): void {
    this.countryCityService.getCountries().subscribe({
      next: (res: any) => {
        this.countries = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  getCitiesByCountry(countryId: any, resetCity: boolean = true): void {
    if (!countryId) {
      this.cities = [];

      if (resetCity) {
        this.data.patchValue({
          city_id: null
        });
      }

      return;
    }

    this.countryCityService.getCitiesByCountry(countryId).subscribe({
      next: (res: any) => {
        this.cities = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  onCountryChange(): void {
    const countryId = this.data.get('country_id')?.value;

    this.data.patchValue({
      city_id: null
    });

    this.getCitiesByCountry(countryId);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      this.selectedImage = null;
      this.data.patchValue({ image: null });
      return;
    }

    const file = input.files[0];

    this.selectedImage = file;
    this.data.patchValue({ image: file });
    this.data.get('image')?.updateValueAndValidity();
  }

  appendPostDtata(): void {
    this.dataForm = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      if (key === 'image') {
        if (this.selectedImage) {
          this.dataForm.append('image', this.selectedImage);
        }
        return;
      }

      if (typeof value === 'boolean') {
        this.dataForm.append(key, value ? '1' : '0');
        return;
      }

      if (value === null || value === undefined) {
        if (
          key === 'country_id' ||
          key === 'city_id' ||
          key === 'name_ar' ||
          key === 'specialty' ||
          key === 'industry' ||
          key === 'tel' ||
          key === 'fax' ||
          key === 'address' ||
          key === 'contact_email' ||
          key === 'facebook' ||
          key === 'linkedin'
        ) {
          this.dataForm.append(key, '');
        }

        return;
      }

      this.dataForm.append(key, value.toString());
    });
  }

  onSubmit(): void {
    if (this.data.invalid || this.isSubmitting) {
      this.data.markAllAsTouched();
      return;
    }

    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd(): void {
    this.isSubmitting = true;
    this.contentReady = false;

    this._company.create(this.dataForm).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;

        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء الشركة" : 'company created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.router.navigateByUrl('/companies');
      },
      error: (err: any) => {
        console.log(err);

        this.isSubmitting = false;
        this.contentReady = true;

        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل إنشاء الشركة" : 'company not created',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }

  onEdit(): void {
    this.isSubmitting = true;
    this.contentReady = false;

    const username = localStorage.getItem("username") || "Unknown";
    this.dataForm.append('editor', username);

    this._company.update(this.editId, this.dataForm).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;

        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل الشركة" : 'company updated',
          showConfirmButton: false,
          timer: 1500,
        });

        this.router.navigateByUrl('/companies');
      },
      error: (err: any) => {
        console.log(err);

        this.isSubmitting = false;
        this.contentReady = true;

        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل الشركة" : 'company not updated',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }
}